import { CwtDictionary } from "@cawita/core-front";
import { CwtApiEntity, CwtCrudContract, CwtModel, CwtProp } from "@cawita/core-front/api";
import { Client } from "../client";
import { CustomFieldType } from "./custom-field-type.model";

@CwtModel({ name: 'custom-field' })
@CwtCrudContract({ path: 'for-machine/custom-field', identifier: 'for-machine' })
@CwtCrudContract({ path: 'for-manager/client/:clientId/custom-field', identifier: 'for-manager' })
@CwtCrudContract({ path: 'custom-field', identifier: 'for-admin' })
export class CustomField extends CwtApiEntity {
    @CwtProp() client: Client;
    @CwtProp() type: CustomFieldType;
    @CwtProp() name: CwtDictionary;
    @CwtProp() enumValues: { key: string, label: CwtDictionary }[];
    @CwtProp() isMultiSelect: boolean;

    public get supportsFilters() { return this.type == CustomFieldType.Enum; }
}